import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCol, {
    attrs: {
      "cols": "12",
      "md": _vm.dynamicInputCols
    }
  }, [_vm.currentFieldConfig ? _c('div', [_vm.currentFieldConfig.type === 'text' ? _c('TextInputField', {
    attrs: {
      "value": _vm.inputValues.value,
      "label": _vm.currentFieldConfig.inputLabel || _vm.$i18n_t('Core.MultiSearch.labels.value'),
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm._e(), _vm.currentFieldConfig.type === 'select' && !_vm.currentFieldConfig.fetchOptions ? _c('Select', {
    attrs: {
      "value": _vm.inputValues.value,
      "select-options": _vm.selectOptions,
      "label": _vm.currentFieldConfig.inputLabel || _vm.$i18n_t('Core.MultiSearch.labels.value'),
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm.currentFieldConfig.type === 'select' && _vm.currentFieldConfig.fetchOptions && _vm.currentFieldConfig.searchLocally ? _c('AutoCompleteWithClientSideSearch', {
    attrs: {
      "value": _vm.inputValues.value,
      "select-options": _vm.selectOptions,
      "label": _vm.currentFieldConfig.inputLabel || _vm.$i18n_t('Core.MultiSearch.labels.value'),
      "is-loading-options": _vm.isLoadingOptions,
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm.currentFieldConfig.type === 'select' && _vm.currentFieldConfig.fetchOptions ? _c('AutoCompleteWithServerSideSearch', {
    attrs: {
      "value": _vm.inputValues.value,
      "select-options": _vm.selectOptions,
      "label": _vm.currentFieldConfig.inputLabel || _vm.$i18n_t('Core.MultiSearch.labels.value'),
      "is-loading-options": _vm.isLoadingOptions,
      "search-term": _vm.searchTerm,
      "can-load-more": _vm.canLoadMore,
      "is-loading-more": _vm.isLoadingMore,
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "search-input": function ($event) {
        return _vm.$emit('search-input', $event);
      },
      "intersect": function ($event) {
        return _vm.$emit('intersect', $event);
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm.currentFieldConfig.type === 'keyValue' ? _c('KeyValueField', {
    attrs: {
      "value": _vm.inputValues.value,
      "key-value": _vm.inputValues.key,
      "has-key-options": _vm.hasKeyOptions,
      "key-options": _vm.keyOptions,
      "has-value-options": _vm.hasValueOptions,
      "value-options": _vm.valueOptions,
      "is-loading-key-options": _vm.isLoadingKeyOptions,
      "is-loading-value-options": _vm.isLoadingValueOptions,
      "key-placeholder": _vm.currentFieldConfig.keyPlaceholder,
      "key-search-term": _vm.keySearchTerm,
      "can-load-more-key-options": _vm.canLoadMoreKeyOptions,
      "is-loading-more-key-options": _vm.isLoadingMoreKeyOptions,
      "value-placeholder": _vm.currentFieldConfig.valuePlaceholder,
      "value-search-term": _vm.valueSearchTerm,
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input-key": function ($event) {
        return _vm.$emit('input-key', $event);
      },
      "input-value": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "key-search-input": function ($event) {
        return _vm.$emit('key-search-input', $event);
      },
      "key-intersect": function ($event) {
        return _vm.$emit('key-intersect', $event);
      },
      "value-search-input": function ($event) {
        return _vm.$emit('value-search-input', $event);
      },
      "key-change": function ($event) {
        return _vm.$emit('key-change');
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm.currentFieldConfig.type === 'dtwin' ? _c('TwinTreeview', {
    ref: "twinTreeview",
    attrs: {
      "value": _vm.inputValues.value,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "can-add-rule": _vm.canAddRule,
      "dense": _vm.dense,
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input-value', $event);
      },
      "add-rule": function ($event) {
        return _vm.$emit('add-rule');
      }
    }
  }) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };